import _ from 'lodash';
import React, { Component } from 'react';
import { getElementIcon, getElementName } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import styles from './MenuElementStyles';
import PropTypes from 'prop-types';
import Radium from 'radium';
import CustomSvgIcon from 'crazyEditor/components/EditorUI/BaseUI/CustomSvgIcon/CustomSvgIcon';
import * as Colors from 'material-ui/styles/colors';
import FlatButton from 'material-ui/FlatButton';
import stylesCSS from './MenuElement.scss';
import TooltipWrapper from 'shared/components/TooltipWrapper';
@Radium
export default class MenuElement extends Component {
  render() {
    const { onMouseEnter, onMouseLeave, active, elementType, responsive, labelStyle, tooltipStyle, noIcon, style, ...props } = this.props;
    let {icon, label} = this.props;
    if (elementType) {
      icon = icon || <CustomSvgIcon color={_.get(labelStyle, 'color')} path={getElementIcon(elementType)}/>;
      label = label || getElementName(elementType);
    }
    return (
      <span style={[responsive ? styles.menuElementWrapperResponsive : styles.menuElementWrapper]} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <FlatButton className={responsive ? [stylesCSS.menuElement, stylesCSS.menuElementResponsive].join(' ') : stylesCSS.menuElement}
                    labelStyle={{...styles.menuElementLabel, ...labelStyle, textTransform: noIcon ? 'none' : undefined, fontSize: noIcon ? 16 : undefined}}
                    style={_.assign({}, styles.menuElementButton, active && styles.menuElementButtonActive, style, {paddingLeft: noIcon ? 10 : 8})}
                    label={label}
                    icon={noIcon ? undefined : icon}
                    containerElement="div" // There is a firefox bug that doesn't allow buttons to be draggable
                    {..._.omit(props, ['templateTag', 'elementPreset', 'left', 'icon', 'elementSize', 'icon', 'label', 'stageLayoutHeight', 'connectDragSource', 'connectDragPreview', 'stageLayoutHeight'])}
        />
      </span>
    );
  }
}

MenuElement.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.node,
  style: PropTypes.object,
};